<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialogCategoryTree"
      persistent
      scrollable
      max-width="450px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Select Category</span>
        </v-card-title>
        <v-card-text>
          <template>
            <template>
              <v-treeview
                v-if="categories != ''"
                v-model="selectionCategory"
                class=""
                open-on-click
                rounded
                hoverable
                selectable
                :items="categories"
                item-key="categoryid"
                return-object
              >
                <template v-slot:prepend="{ item }">
                  <template>
                    <div class="radioBTN" v-if="item.categoryname != undefined">
                      {{ item.categoryname }}
                    </div>
                  </template>
                </template>
              </v-treeview>
            </template>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="closeCateDialog()">
            close
          </v-btn>
          <v-btn color="green darken-1" text @click="sendCategories()"> Select </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>


<script>
export default {
  props: ["dialogCategoryTree" , "selectedCategories"],
  data() {
    return {
      categories: [],
      selectionCategory: [],
      radioGroup: null,
      SelectedCategory: {
        ID: "",
        Name: "",
      },
    };
  },

  mounted() {
    this.getTreeItems();
    this.selectionCategory = this.selectedCategories
  },

  methods: {
    getTreeItems() {
      this.$store.dispatch("GetFromAPI", "/admin/category?status=true").then((response) => {
        this.categories = response["data"]["data"];
      });
    },
    selectedCategory(item) {
      this.SelectedCategory.Name = item.categoryname;
      this.SelectedCategory.ID = item.categoryid;
    },
    SendCategory() {
      if (this.SelectedCategory.Name == "" || this.SelectedCategory.ID == "") {
        this.$store.dispatch("PushErrorMsg", "Data Not Valid");
      } else {
        this.$emit("SendCategoryValue", this.SelectedCategory);
      }
    },
    sendCategories(){
        this.$emit("closeCatDialogWithCategories", this.selectionCategory);
    },
    closeCateDialog() {
      this.$emit("closeCatDialog", false);
    },
  },
};
</script>
